import React, { useEffect, createElement } from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Identity } from './components/Identity';
import { Philosophy } from './components/Philosophy';
import { Activities } from './components/Activities';
import { Jurisdiction } from './components/Jurisdiction';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    const metaName = 'facebook-domain-verification';
    let meta = document.querySelector(`meta[name="${metaName}"]`);
    if (!meta) {
      meta = document.createElement('meta');
      meta.setAttribute('name', metaName);
      document.head.appendChild(meta);
    }
    meta.setAttribute('content', 'bzx1he6q7iimdtfxv8fw5zs63u16s9');
  }, []);
  return <div className="min-h-screen bg-navy text-cream selection:bg-gold selection:text-navy" data-id="element-0" data-mp="28te3lff7pdo5">
      <Navbar data-id="element-1" data-mp="23u9t8lgjx9w8" />
      <main data-id="element-2" data-mp="23ujl6el5pr4k">
        <Hero data-id="element-3" data-mp="23v2s7099qv3t" />
        <Identity data-id="element-4" data-mp="23t8eo70bu59r" />
        <Philosophy data-id="element-5" data-mp="3ik7gwiph6frp" />
        <Activities data-id="element-6" data-mp="3ikr0e3urxc7u" />
        <Jurisdiction data-id="element-7" data-mp="3ij65ue8glt9z" />
        <Contact data-id="element-8" data-mp="3ihv22ef0kliv" />
      </main>
      <Footer data-id="element-9" data-mp="3mlavz2zp87rv" />
    </div>;
}